import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.segplus.com.br/api/v1',
  //baseURL: 'https://api2.segplus.com.br/cgi-bin/ApiSegplusRCFIsapi.dll/api/v1',
  //baseURL: 'http://www.segplus.com.br:9001/api/v1',
  //baseURL: 'http://192.168.1.16:9001/api/v1',
  headers: {
    'Content-Type': 'application/json'
  }
})

const setToken = aToken => {
  api.defaults.headers.common.Authorization = aToken
}

export default api
export { setToken }
